// eslint-disable-next-line max-classes-per-file
import { Api as EvergisApi } from "@evergis/api";

import { RemoteTaskManagerService } from "./services/RemoteTaskManager";
import { ChatService } from "./services/ChatService";

export const LOGIN_ROUTE = "/signin";

const trimSlashes = (str: string) => str.replace(/^\/|\/$/g, "");

const joinUrlParts = (...parts: string[]) =>
  parts
    .map(p => trimSlashes(p))
    .filter(p => !!p)
    .join("/");

const SP_PATH = `/${joinUrlParts(process.env.API_PROXY_PREFIX || "", process.env.URL || "")}/`;

const WS_PROTOCOL = location.protocol === "https:" ? "wss" : "ws";

const WS_URL_BASE = `${WS_PROTOCOL}://${location.host}`;

const WS_URL = joinUrlParts(WS_URL_BASE, SP_PATH, "ws");

const SNAPPING_HUB_URL = `${location.origin}/${joinUrlParts(
  process.env.API_PROXY_PREFIX || "",
  process.env.URL || "",
)}/snapping`;

class Api extends EvergisApi {
  readonly remoteTaskManager: RemoteTaskManagerService;

  constructor(args) {
    super(args);

    this.remoteTaskManager = new RemoteTaskManagerService(this.http);
  }

  async logout() {
    if ((this.isShared || this.isPresentation) && !this.account.isAuth) {
      return;
    }

    await super.logout();
    window.location.pathname !== LOGIN_ROUTE && (window.location.href = LOGIN_ROUTE);
  }
}

export class ChatApi extends EvergisApi {
  readonly chat: ChatService;

  constructor(args) {
    super(args);

    this.chat = new ChatService(this.http);
  }
}

export const api = new Api({
  url: SP_PATH,
  urlPath: process.env.URL_PATH,
  wsUrl: WS_URL,
  wsKeepAlive: true,
  snappingHubUrl: SNAPPING_HUB_URL,
});

export const newApi = new Api({
  url: process.env.NEW_SP_URL ? `${process.env.NEW_SP_URL}${process.env.URL || ""}` : SP_PATH,
  urlPath: process.env.URL_PATH,
});
